// React
import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

// Styles
import styles from './LeadsFilter.module.css';

// Types
import { LeadsCallQueryParamsType, LeadTabId } from '../../../../types/LeadsList';

type LeadsTabQuickFilterComponentProps = {
    filterParams: LeadsCallQueryParamsType;
    activeTab: LeadTabId;
    onTabChange: (tab: LeadTabId) => void;
};

export const tabs: LeadTabId[] = ['workflowTodos', 'workflowOpen', 'allLeads'];
export const defaultTab: LeadTabId = tabs[0];

/**
 * Tab component for filter list by given parameters as simple click.
 *
 * @param props LeadsTabQuickFilterComponentProps
 * @returns React.ReactElement
 */
export default function LeadsTabQuickFilterComponent(props: LeadsTabQuickFilterComponentProps): React.ReactElement {
    const { t } = useTranslation();

    return (
        <div className={styles.filterTabs}>
            {tabs.map((tab) => {
                return (
                    <div
                        key={tab}
                        onClick={() => props.onTabChange(tab)}
                        className={classNames({
                            [styles.tabActive]: props.activeTab == tab,
                            [styles.tab]: true,
                        })}
                        data-testid={`tab-${tab}`}>
                        {t(`lead.list.tabs.${tab}`)}
                    </div>
                );
            })}
        </div>
    );
}
